import { useEffect, useState } from 'react';

import { detectStorePlatformFromNavigator, type StorePlatform } from '../utils/storePlatform';

/** Client-side store platform (updates after mount for correct mobile badges/links). */
export function useStorePlatform(): StorePlatform {
  const [platform, setPlatform] = useState<StorePlatform>('other');

  useEffect(() => {
    setPlatform(detectStorePlatformFromNavigator());
  }, []);

  return platform;
}
